// Flat TreeSelect data from the workspace's (already caller-clamped) markets,
// A to Z. Callers collect markets region by region, so their order is the
// regions' order, which nobody scanning for a country expects.
export const buildTreeData = (markets) => {
  if (!markets || markets.length === 0) {
    return [
      {
        value: "no_markets",
        title: "No markets available for this workspace",
        key: "no_markets",
        disabled: true,
      },
    ];
  }
  return [...markets]
    .sort((a, b) => a.localeCompare(b))
    .map((market) => ({
      value: market,
      title: market,
      key: market,
      country_code: market,
    }));
};
